import React, { Component } from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from "@material-ui/core/Typography/Typography";

import {
    FacebookIcon,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    FacebookShareButton,
    FacebookShareCount,
    LinkedinIcon,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton
} from "react-share";
import Social from "./Social";


const useStyles = makeStyles((theme) => {
    return {
        root: {
            border: 'none',
            width: 204
        },
        comment: {
          paddingTop: 10
        },
        icon: {
            display: 'inline-block',
            marginRight: 5
        },
        like: {
            maxWidth: 190,
            marginTop: 10
        }
}});

export default function Share(props) {
    const classes = useStyles();

    const title = 'DASH CARSALES';
    const shareUrl = window.location.href;

    return null;

    return (
        <Card className={classes.root} variant="outlined">
            <CardContent className={classes.content}>
                <Typography color="textSecondary" className={classes.about}>
                    Share & Like
                </Typography>
                <Typography variant="body2" component="p" className={classes.comment}>
                    <div className={classes.icon}>
                        <FacebookShareButton
                            url={shareUrl}
                            quote={title}
                            className=""
                        >
                            <FacebookIcon size={32} round />
                        </FacebookShareButton>

                        <div>
                            <FacebookShareCount url={shareUrl} className="">
                                {count => count}
                            </FacebookShareCount>
                        </div>
                    </div>

                    {/*<div className={classes.icon}>
                        <FacebookMessengerShareButton
                            url={shareUrl}
                            appId="521270401588372"
                            className=""
                        >
                            <FacebookMessengerIcon size={32} round />
                        </FacebookMessengerShareButton>
                    </div>*/}

                    <div className={classes.icon}>
                        <TwitterShareButton
                            url={shareUrl}
                            title={title}
                            className=""
                        >
                            <TwitterIcon size={32} round />
                        </TwitterShareButton>
                    </div>

                    <div className={classes.icon}>
                        <LinkedinShareButton url={shareUrl} className="">
                            <LinkedinIcon size={32} round />
                        </LinkedinShareButton>
                    </div>

                    <div className={classes.like}>
                        <div className="fb-like" data-href={window.location.href} data-width="" data-layout="button"
                             data-action="like" data-size="large" data-share="true"></div>
                    </div>
                </Typography>
            </CardContent>
        </Card>
    );
}